<template>
    <div
        class="ppv2-bg-[#F3F3F5] ppv2-bg-opacity-[12%] ppv2-rounded-[12px] md:ppv2-p-5 ppv2-p-3 ppv2-border ppv2-border-[#7D2DBD] ppv2-flex ppv2-flex-col"
    >
        <h2 class="poppinsSemiBold ppv2-text-black ppv2-mb-3" :style="{ fontSize: normalizeFontSize(20) }">
            {{ title }}
        </h2>
        <p class="poppinsLight ppv2-text-black ppv2-mb-3 ppv2-min-h-[37px]" :style="{ fontSize: normalizeFontSize(15) }">
            {{ description }}
        </p>

        <form @submit.prevent="$emit('submit')" class="ppv2-flex-1 ppv2-flex ppv2-flex-col">
            <!-- Form Content Slot -->
            <div class="ppv2-flex-1">
                <slot></slot>
            </div>

            <!-- Submit Button -->
            <div class="ppv2-mt-8">
                <BaseButton
                    type="submit"
                    variant="primary"
                    :loading="loading"
                    customClass="!ppv2-min-w-[170px]"
                    :customFontSize="16"
                    :customHeight="40"
                >
                    {{ buttonLabel }}
                </BaseButton>
            </div>
        </form>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'
import BaseButton from '../../Shared/BaseButton.vue'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    name: 'ExportCard',
    components: {
        BaseButton,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        buttonLabel: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        buttonClass: {
            type: String,
            default: '',
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped></style>
